import React from 'react';
import { Building2, Hotel, TrendingUp } from 'lucide-react';

export const Services = () => {
  const services = [
    {
      icon: Hotel,
      title: 'Hospitalité de Luxe',
      description: 'Conseil stratégique pour hôtels, resorts et établissements haut de gamme. Optimisation opérationnelle et positionnement premium.',
      image: 'https://images.unsplash.com/photo-1561501900-3701fa6a0864?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQyMTd8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBob3RlbHxlbnwwfHx8fDE3NjcyODE3NDF8MA&ixlib=rb-4.1.0&q=85',
    },
    {
      icon: Building2,
      title: 'Immobilier d\'Exception',
      description: 'Accompagnement dans l\'acquisition, le développement et la valorisation de propriétés de prestige. Expertise du marché du luxe.',
      image: 'https://images.pexels.com/photos/8134848/pexels-photo-8134848.jpeg',
    },
    {
      icon: TrendingUp,
      title: 'Investissements Stratégiques',
      description: 'Analyse et gestion de portefeuilles d\'investissement premium. Opportunités exclusives dans les secteurs à forte valeur ajoutée.',
      image: 'https://images.pexels.com/photos/5716001/pexels-photo-5716001.jpeg',
    },
  ];

  return (
    <section id="services" style={styles.section} className="services-section">
      <div style={styles.container}>
        <div style={styles.header}>
          <h2 style={styles.title} className="services-title">Nos Services</h2>
          <p style={styles.subtitle}>
            Une expertise pointue dans trois domaines d'excellence
          </p>
        </div>

        <div style={styles.servicesGrid} className="services-grid">
          {services.map((service, index) => (
            <div key={index} style={styles.serviceCard} className="transition-smooth">
              <div style={styles.imageContainer}>
                <img src={service.image} alt={service.title} style={styles.serviceImage} />
                <div style={styles.imageOverlay}></div>
              </div>
              <div style={styles.cardContent}>
                <service.icon size={40} style={styles.serviceIcon} />
                <h3 style={styles.serviceTitle}>{service.title}</h3>
                <p style={styles.serviceDescription}>{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: '120px 40px',
    background: '#0a0a0a',
  },
  container: {
    maxWidth: '1400px',
    margin: '0 auto',
  },
  header: {
    textAlign: 'center',
    marginBottom: '80px',
  },
  title: {
    fontSize: '48px',
    fontWeight: '700',
    color: '#FFFFFF',
    marginBottom: '24px',
    letterSpacing: '-0.02em',
  },
  subtitle: {
    fontSize: '20px',
    color: 'rgba(255, 255, 255, 0.7)',
    maxWidth: '700px',
    margin: '0 auto',
  },
  servicesGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
    gap: '40px',
  },
  serviceCard: {
    background: '#121212',
    border: '1px solid rgba(212, 175, 55, 0.2)',
    overflow: 'hidden',
    cursor: 'pointer',
  },
  imageContainer: {
    position: 'relative',
    height: '300px',
    overflow: 'hidden',
  },
  serviceImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transition: 'transform 0.6s ease',
  },
  imageOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, transparent 100%)',
  },
  cardContent: {
    padding: '40px',
  },
  serviceIcon: {
    color: '#D4AF37',
    marginBottom: '20px',
  },
  serviceTitle: {
    fontSize: '24px',
    fontWeight: '600',
    color: '#FFFFFF',
    marginBottom: '16px',
  },
  serviceDescription: {
    fontSize: '16px',
    lineHeight: '1.8',
    color: 'rgba(255, 255, 255, 0.7)',
  },
};